
export const timeslots = {
    values: {
        "AT": 0,
        "AM": 1,
        "PM": 2,
        "ST": 3    
    },
    codes: {
        0: "AT",
        1: "AM",
        2: "PM",
        3: "ST"
    }
};
